import { Card, CardBody, Row, Col } from "reactstrap"

export const SelectOrderDetails = ({ selectedOffer }) => {
    return (
        <div className="border border-1 rounded-1 p-3">
            <Row>
                <Col lg={3} md={4} sm={12} className='mb-3'>
                    <h5 className="fs-14 text-black fw-semibold">
                        Offer Name
                    </h5>
                    <h5 className="fs-14 text-black fw-normal">
                        {selectedOffer?.offerName}
                    </h5>
                </Col>
                <Col lg={3} md={4} sm={12} className='mb-3'>
                    <h5 className="fs-14 text-black fw-semibold">
                        Service Name
                    </h5>
                    <h5 className="fs-14 text-black fw-normal">
                        {selectedOffer?.serviceName.length > 0 ? selectedOffer?.serviceName : '-'}
                    </h5>
                </Col>
                <Col lg={3} md={4} sm={12} className='mb-3'>
                    <h5 className="fs-14 text-black fw-semibold">
                        Offer Code
                    </h5>
                    <h5 className="fs-14 text-black fw-normal">
                        {selectedOffer?.offerCode}
                    </h5>
                </Col>
                <Col lg={3} md={4} sm={12} className='mb-3 mb-md-0'>
                    <h5 className="fs-14 text-black fw-semibold">
                        Time Period
                    </h5>
                    <h5 className="fs-14 text-black fw-normal">
                        {selectedOffer?.termValidity}
                    </h5>
                </Col>
                <Col lg={3} md={4} sm={12} className='mb-3 mb-md-0'>
                    <h5 className="fs-14 text-black fw-semibold">
                        Offer Validity
                    </h5>
                    <h5 className="fs-14 text-black fw-normal">
                        {selectedOffer?.validityFrom} - {selectedOffer?.validityTo}
                    </h5>
                </Col>
                <Col lg={3} md={4} sm={12} className='mb-3 mb-md-0'>
                    <h5 className="fs-14 text-black fw-semibold">
                        Description
                    </h5>
                    <h5 className="fs-14 text-black fw-normal">
                        {selectedOffer?.description.length > 0 ? selectedOffer?.description : '-'}
                    </h5>
                </Col>
            </Row>
        </div>

    )
}